<template>
  <div>
    <div v-if="!disabled" :id="randomKey" />
    <div v-else v-html="value" />
  </div>
</template>

<script>
import E from 'wangeditor';

export default {
  name: 'DYRichLocalEditor',
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      randomKey: 'id' + Math.ceil(Math.random()),
      editor: undefined,
      initialised: false,
    }
  },
  watch: {
    value(val) {
      if (val && !this.initialised) {
        this.setDefaultText(val)
      }
    }
  },
  mounted() {
    !this.disabled && this.init()
  },
  destroyed() {
    this.editor?.destroy()
  },
  methods: {
    init() {
      if (document.getElementById(this.randomKey)) {
        const editor = new E(`#${this.randomKey}`)
        this.editor = editor
        this.editor.config.uploadImgShowBase64 = true
        this.editor.config.zIndex = 500
        this.editor.config.onchange = (val) => {
          this.changeText(val)
        }
        this.editor.config.menus = [
          'undo',
          'redo',
          'head',
          'bold',
          'fontSize',
          'fontName',
          'italic',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'backColor',
          'link',
          'list',
          'todo',
          'justify',
          'quote',
          'emoticon',
          'image',
          'video',
          'table',
          // 'code',
          'splitLine'
        ]
        // 限制图片大小
        // this.editor.config.uploadImgMaxSize = 1 * 1024 * 1024
        // 限制上传图片数量
        // this.editor.config.uploadImgMaxLength = 5
        if (this.disabled) {
          this.editor.config.readonly = true
        }
        this.editor.create()
      }
    },
    setDefaultText(defaultVal) {
      this.editor?.txt.append(defaultVal)
    },
    changeText(val) {
      if (this.interval) {
        clearTimeout(this.interval)
        this.interval = undefined
      }
      this.interval = setTimeout(() => {
        if (this.initialised) {
          this.$emit('input', val)
        } else {
          this.initialised = true
        }
      }, 300)
    }
  }
}
</script>
<style scoped lang="scss">
</style>
